import $ from 'jquery';

window.jQuery = $;
window.$ = $;

import 'tinymce/tinymce';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/contextmenu';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/help';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/image';
import 'tinymce/plugins/imagetools';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';

import 'jquery-ui-sortable-npm';
import '../../plugins/jquery.htmlClean.min';
var sanitizeHtml = require('sanitize-html');

import Vars from '../../vars'

import Action from "../classes/Action";
import Validation from './../classes/Validation';

import Modal from '../../components/Modal';
import Request from '../../components/request';
import Utils from '../../components/utils';

class Site {
    constructor (args) {
        let self = this;

        self._setArgs(args);
        self._init();
    };

    _elems = {
        $content   : $(),
        $create    : $(),
        $edit      : $(),
        $params    : $(),
        $crmAttach : $()
    };

    _const = {
        entities : 'sites',
        entity   : 'site',
        id       : 'site_id',
        title : {
            add  : 'Добавление нового сайта',
            edit : 'Редактирование сайта'
        }
    };

    _args = {
        mode : '',
        id   : ''
    };

    _state = {
        modal          : {},
        fields         : {},
        item           : {},
        items          : {},
        objects        : [],
        object         : {},
        paramsFields   : {},
        paramsDropzone : {}
    };

    _actions = {
        activate : {
            title: 'Активация сайта'
        },
        deactivate : {
            title: 'Деактивация сайта'
        },
        remove : {
            title: 'Удаление сайта'
        },
        confirmation : {
            title: 'этот сайт'
        },
        done : {
            activate : function(args) {
                let self = args.self;
                self._state.item = args[self._const.entity];

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Сайты',
                            href  : '#' + self._const.entities
                        },
                        {
                            title : self._state.item.object.name
                        }
                    ],
                    dropdown : null,
                    activate : self._state.item.is_default ? null : {
                        id        : self._state.item.site_id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                $('.aside').trigger('update');

                self._bindElements();
                self._bindUI();
            },
            deactivate : function(args) {
                let self = args.self;
                self._state.item = args[self._const.entity];

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Сайты',
                            href  : '#' + self._const.entities
                        },
                        {
                            title : self._state.item.object.name
                        }
                    ],
                    dropdown : null,
                    activate : self._state.item.is_default ? null : {
                        id        : self._state.item.site_id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                $('.aside').trigger('update');

                self._bindElements();
                self._bindUI();
            }
        }
    };

    _setArgs = (args) => {
        let self = this;

        self._args.mode = args.mode;
        self._args.id   = args[self._const.id];
    };

    _setFields = () => {
        let self = this;

        self._state.fields = {};
    };

    _setParamsFields = () => {
        let self = this;

        let documentLinks = [
            {
                name : 'Не указывать'
            }
        ]
        self._state.documentLinks.forEach(dl => {
            documentLinks[dl.id] = {
                name : dl.name
            }
        })

        self._state.paramsFields = {
            domain : {
                title      : 'Домен',
                type       : 'string',
                required   : false,
                validation : 'nullable', //,domain',
                value      : self._state.item.domain
            },
            is_https : {
                title : 'Сформировать SSL-сертификат?',
                type  : 'checkbox',
                value : self._state.item.is_https
            },
            entities : {
                title : 'ЧПУ, человекопонятный URL',
                type  : 'group',
                description : 'Редактирование адресов страниц сайта',
                items : {
                    buildings : {
                        title       : 'Дома',
                        type        : 'string',
                        required    : false,
                        placeholder : 'buildings',
                        validation  : 'nullable,lang:en,integer,hyphen',
                        value       : self._state.item.entities && 0 in self._state.item.entities ? self._state.item.entities[0] : null
                    },
                    sections : {
                        title       : 'Секции',
                        type        : 'string',
                        required    : false,
                        placeholder : 'sections',
                        validation  : 'nullable,lang:en,integer,hyphen',
                        value       : self._state.item.entities && 0 in self._state.item.entities ? self._state.item.entities[1] : null
                    },
                    floors : {
                        title       : 'Этажи',
                        type        : 'string',
                        required    : false,
                        placeholder : 'floors',
                        validation  : 'nullable,lang:en,integer,hyphen',
                        value       : self._state.item.entities && 0 in self._state.item.entities ? self._state.item.entities[2] : null
                    },
                    flats : {
                        title       : 'Помещения',
                        type        : 'string',
                        required    : false,
                        placeholder : 'id',
                        validation  : 'nullable,lang:en,integer,hyphen',
                        value       : self._state.item.entities && 0 in self._state.item.entities ? self._state.item.entities[3] : null
                    }
                }
            },
            counters : {
                title : 'Счетчики',
                type  : 'group',
                items : {
                    yandex : {
                        title       : 'Яндекс.Метрика',
                        type        : 'string',
                        required    : false,
                        validation  : 'nullable,yandex.metrika',
                        value       : self._state.item.counters && 'yandex' in self._state.item.counters ? self._state.item.counters['yandex'] : null,
                        placeholder : '24562465'
                    },
                    google : {
                        title       : 'Google Analytics',
                        type        : 'string',
                        required    : false,
                        validation  : 'nullable,google.analytics',
                        value       : self._state.item.counters && 'google' in self._state.item.counters ? self._state.item.counters['google'] : null,
                        placeholder : 'UA-92342075-1'
                    },
                    facebook_pixel : {
                        title       : 'Facebook Pixel',
                        type        : 'string',
                        required    : false,
                        validation  : 'nullable,facebook.pixel',
                        value       : self._state.item.counters && 'facebook_pixel' in self._state.item.counters ? self._state.item.counters['facebook_pixel'] : null,
                        placeholder : '789446564154896'
                    },
                    vk_pixel : {
                        title       : 'ВКонтакте Pixel',
                        type        : 'string',
                        required    : false,
                        validation  : 'nullable',
                        value       : self._state.item.counters && 'vk_pixel' in self._state.item.counters ? self._state.item.counters['vk_pixel'] : null,
                        placeholder : 'VK-RTRG-13498765-32vio'
                    }
                }
            },
            services : {
                title : 'Сервисы',
                type  : 'group',
                items : {
                    service_yandex : {
                        title       : 'Яндекс.Карта',
                        type        : 'string',
                        required    : false,
                        validation  : 'nullable,lang:en,integer,hyphen,max:50',
                        value       : self._state.item.services && 'yandex' in self._state.item.services ? self._state.item.services['yandex'] : null,
                        placeholder : 'a5e87898-726c-40ba-90ab-492c68455101'
                    }
                }
            },
            documents : {
                title : 'Документы',
                type  : 'group',
                items : {
                    confidential : {
                        title   : 'Политика конфиденциальности',
                        type    : 'select',
                        options : documentLinks,
                        value   : self._state.item.document_link.length ? self._state.item.document_link[0].id : null,
                        description : 'Создать свою политику конфиденциальности можете в разделе "Регистрационная информация"'
                    }
                }
            },
            favicon : {
                title    : 'Favicon',
                type     : 'file',
                required : false
            }
        };
    };

    _setParamsDropzone = () => {
        let self = this;

        self._state.paramsDropzone = {
            items   : {
                favicon : {
                    options: {
                        url: '/api/' + self._const.entities + '/favicon/create?api_token=' + auth.user.api_token,
                        addRemoveLinks  : true,
                        paramName       : 'favicon',
                        thumbnailWidth  : 78,
                        thumbnailHeight : 78,
                        maxFilesize     : 10,
                        maxFiles        : 1,
                        acceptedFiles   : 'image/*',
                        timeout         : 180000,

                        dictDefaultMessage: 'Чтобы загрузить изображение, выберите или просто перетащите его в это поле',
                        maxfilesexceeded: function (file) {
                            //this.removeAllFiles();
                            //this.addFile(file);
                        }
                    },
                    complete: function (file, response, dropzone, item) {
                        let $file = $(file._removeLink).parent();
                        if (!file.image) file.image = response ? response.image : null;

                        if (file.image) {
                            $('<input />').attr('type', 'hidden').attr('name', 'site[favicon_id]').val(file.image.id).appendTo($file);
                            if (file.image.path_to_extra_large !== '')
                                $('<a />').attr('href', '/' + file.image.path_to_extra_large).attr('target', '_blank').addClass('dz-link').appendTo($file);
                            else
                                $('<a />').attr('href', '/' + file.image.path_to_original).attr('target', '_blank').addClass('dz-link').appendTo($file);

                            $('<a />').attr('href', '#').addClass('dz-remove with-confirmation').html('<i class="fa fa-close" />').appendTo($file).click(function(e) {
                                e.preventDefault();

                                new Modal({
                                    title   : 'Удаление изображения',
                                    content : Utils.renderProfileTemplate('removing-confirmation', {
                                        args : {
                                            confirmation : {
                                                title : 'это изображение'
                                            }
                                        }
                                    }),
                                    confirm : function(args) {
                                        args.modal && args.modal.trigger('close');
                                        dropzone.removeFile(file);
                                    }
                                });
                            });

                            $file.find('.dz-image').css('background-image', 'url(\'/' + (file.image.path_to_small ? file.image.path_to_small : file.image.path_to_original) + '\')');
                            $file.find('.dz-image img').remove();
                        }
                    },
                    done: function (dropzone, entity) {
                        if (self._state.item && self._state.item.favicon) {
                            let file = {name: '', size: 1};
                            dropzone.emit('addedfile', file);
                            dropzone.emit('thumbnail', file, '/' + (self._state.item.favicon.path_to_tiny ? self._state.item.favicon.path_to_tiny : self._state.item.favicon.path_to_original));
                            file.image = self._state.item.favicon;
                            dropzone.emit('processing', file);
                            dropzone.emit('complete', file);
                            dropzone.files.push(file);
                        }
                    }
                }
            }
        }
    };

    _attachCrm = () => {
        let self = this;

        const fields = {
            crm : {
                title    : 'CRM',
                type     : 'select',
                required : true,
                value    : '',
                options  : self._state.crms.filter(function(crm){
                    return crm.type != 'amo_widget';
                }),
                name     : 'display_name',
                id       : 'id'
            }
        };

        let $modal = new Modal({
            title: 'Подключить CRM интеграцию',
            content: Utils.renderProfileTemplate('form', {
                item   : null,
                entity : self._const.entity,
                fields : fields,
                buttons: {
                    one : {
                        class : 'confirm button--edit',
                        title : 'Подключить'
                    },
                    two : {
                        class : 'button--cancel',
                        title : 'Отмена'
                    }
                }
            }),
            closingConfirmation: false,
            confirm : function(args) {
                let $modal = args.modal;
                if (!$modal.length) return;
                let $form = $modal.find('form');
                if (!$form.length) return;

                loader.increase();

                Request.send({
                    path: '/api/' + self._const.entities + '/' + self._state.item[self._const.id] + '/attach/crm',
                    method: 'POST',
                    data: $form.serialize(),
                    done: function (response) {
                        loader.decrease();

                        if (response.error) {
                            //self.profile.callback.error(response.error, form, self.profile);
                            return
                        }

                        self._state.item = response[self._const.entity];
                        $modal.trigger('close');

                        self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                            crumbs : [
                                {
                                    title : 'Главная',
                                    href  : '#'
                                },
                                {
                                    title : 'Сайты',
                                    href  : '#sites'
                                },
                                {
                                    title : self._state.item.object.name
                                }
                            ],
                            dropdown : null,
                            activate : self._state.item.is_default ? null : {
                                id        : self._state.item.site_id,
                                is_active : self._state.item.is_active
                            }
                        });

                        self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                            breadcrumbs          : self._state.breadcrumbs,
                            [self._const.entity] : self._state.item
                        }));
                        self._bindElements();
                        self._bindUI();
                    }
                });
            }
        });

        let $form   = $modal.find('form');
        let $select = $form.find('select[name="' + self._const.entity + '[crm]"]');

        if (!self._state.item.crms) return;
        self._state.item.crms.forEach(function(crm){
            $select.children('option[value="' + crm.id + '"]').attr('disabled', 'disabled');
        });
    };

    _detachCrm = (id) => {
        let self = this;

        let $modal = new Modal({
            title: 		'Открепить интеграцию?',
            content: 	Utils.renderProfileTemplate('info', {
                message : '',
                buttons : {
                    one : {
                        class : 'confirm button--edit',
                        title : 'Открепить'
                    },
                    two : {
                        class : 'button--cancel',
                        title : 'Отмена'
                    }
                }
            }),
            confirm : function(args) {
                let $nmodal = args.modal;

                loader.increase();

                Request.send({
                    path: '/api/' + self._const.entities + '/' + self._state.item[self._const.id] + '/detach/crm',
                    method: 'POST',
                    data: {
                        site : {
                            crm : id
                        }
                    },
                    done: function (response) {
                        loader.decrease();

                        if (response.error) {
                            // self.profile.callback.error(response.error, form, self.profile);
                            return
                        }

                        self._state.item = response[self._const.entity];
                        $nmodal.trigger('close');

                        self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                            breadcrumbs          : self._state.breadcrumbs,
                            [self._const.entity] : self._state.item
                        }));
                        self._bindElements();
                        self._bindUI();
                    }
                });
            }
        });
    };

    _initModal = () => {
        let self = this;

        self._setFields();

        loader.increase();

        let queue = [];
        if (Object.keys(self._state.item).length) {
            queue.push({
                path : '/api/' + self._const.entities + '/' + self._state.item[self._const.id]
            });
        }
        queue.push({
            path : '/api/' + self._const.entities + '/options'
        });

        Request.send({
            queue : queue,
            done : function(response, extraResponse) {
                loader.decrease();

                self._state.item    = Object.keys(self._state.item).length ? response[self._const.entity] : {};

                const options       = Object.keys(self._state.item).length ? extraResponse.options : response.options;
                const objects       = Object.keys(options).length && options.objects ? options.objects : [];
                const objectsShared = options.objects_shared;

                self._state.objects = objects;
                if (objectsShared) {
                    self._state.objects = objects.concat(objectsShared);
                }

                if (!Object.keys(self._state.item).length && !Object.keys(self._state.object).length) {
                    self._initObject();
                    return;
                }

                const object
                    =
                        Object.keys(self._state.item).length
                            ? (self._state.item.object ? self._state.item.object : (self._state.objects ? self._state.objects.filter(function(object){
                                return object.id == self._state.item.object.id;
                            }).pop() : null))
                            : self._state.object;

                const sParts = Object.keys(self._state.item).length ? self._state.item.parts : null;
                let sPartsIds = [];
                if (sParts !== null) {
                    sParts.forEach(function(part){
                        sPartsIds.push(part.id);
                    });
                }

                if (!Object.keys(objects).length) {
                    new Modal({
                        title: 'Сообщение',
                        content: Utils.renderProfileTemplate('warning', {
                            warning : {
                                text : 'Для выполнения операции необходимо добавить хотя бы один комплекс'
                            }
                        }),
                        confirm : function(args) {
                            args.modal && args.modal.trigger('close');
                        }
                    });

                    return;
                }

                self._state.modal = new Modal({
                    title : Object.keys(self._state.item).length ? self._const.title.edit : self._const.title.add,
                    closingConfirmation : true,
                    confirm : function(args){
                        self._bindSubmit(args);
                    },
                    closing : function(args) {
                        self._state.object = {};
                    },
                    content: Utils.renderProfileTemplate(self._const.entity + '-form', {
                        [self._const.entity] : Object.keys(self._state.item).length ? self._state.item : null,
                        fields               : self._state.fields,

                        object               : object,
                        values               : response.values ? response.values : {},

                        options              : options,
                        ad_types             : response.ad_types,
                        buildings            : response.buildings,
                        sections             : response.sections,
                        section_ids          : response.section_ids,
                        section_show_ids     : response.section_show_ids,

                        sParts               : sParts,
                        sPartsIds            : sPartsIds,

                        parts                : options.parts,
                        colors               : options.colors,
                        templates            : options.templates,
                        companies            : options.companies,

                        buttons  : {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Сохранить',
                                type  : 'submit'
                            },
                            two : {
                                class : 'button--cancel',
                                title : 'Отмена'
                            }
                        }
                    })
                });

                self._bindForm();
            }
        });
    };

    _initObject = () => {
        let self = this;

        const fields = {
            object : {
                title    : 'Жилой комплекс',
                type     : 'select',
                required : true,
                value    : '',
                options  : self._state.objects,
                name     : function(object) {
                    let name = '';

                    if (ifacade.constants.objects.types[object.type]) {
                        name += ifacade.constants.objects.types[object.type].short_name + ' ';
                    }
                    name += '"' + object.name + '"';
                    if (!object.is_active) {
                        name += ' (неактивен)';
                    }
                    if (object.shared) {
                        name += '- предоставлен доступ';
                    }

                    return name;
                },
                id       : 'id'
            }
        };

        new Modal({
            title: 'Добавление нового сайта',
            content: Utils.renderProfileTemplate('form', {
                entity  : self._const.entity,
                fields  : fields,
                buttons : {
                    one : {
                        class : 'confirm button--edit',
                        title : 'Далее',
                        type  : 'submit'
                    },
                    two : {
                        class : 'button--cancel',
                        title : 'Отмена'
                    }
                }
            }),
            closingConfirmation: true,
            confirm : function(args) {
                let $modal = args.modal;
                let $form = $modal.find('form');
                if (!$form.length) return;

                let $select = $form.find('select[name="site[object]"]');
                if ($select.val() == null || $select.val() == 'null') {
                    let $error = $('<div/>')
                        .addClass('form__field__error')
                        .text('Выберите из списка вариант');
                    $select.parents('.form-field').append($error);
                    $error.slideDown();
                }
                else {
                    $modal.trigger('close');

                    let objects = self._state.objects.filter(function(object){
                        return object.id == $select.val();
                    });

                    self._state.object = objects[0];
                    self._initModal();
                }
            }
        });
    };

    _initParams = () => {
        let self = this;

        loader.increase();

        Request.send({
            queue : [
                {
                    path : '/api/' + self._const.entities + '/' + self._state.item[self._const.id],
                    data : {
                        info : 'params'
                    },
                },
                {
                    path : '/api/document_links'
                }
            ],
            done : function(response, extraResponse) {
                loader.decrease();
                Utils.scrollToTop();

                if(response.error) return;

                self._state.item = response[self._const.entity];
                self._state.documentLinks = extraResponse.data;

                self._setParamsFields();
                self._setParamsDropzone();

                let $modal = new Modal({
                    title   : 'Настройка параметров',
                    content : Utils.renderProfileTemplate('form', {
                        item   : null,
                        entity : 'site',
                        fields : self._state.paramsFields,
                        buttons: {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Сохранить',
                                type  : 'submit'
                            },
                            two : {
                                class : 'button--cancel',
                                title : 'Отмена'
                            }
                        }
                    }),
                    closingConfirmation : true,
                    dropzone : self._state.paramsDropzone,
                    confirm : function(args) {
                        self._bindParamsSubmit(args)
                    }
                });

                let $domain = $modal.find('[name="' + self._const.entity + '[domain]"]');
                let $sslField = $modal.find('.form-field[data-name="is_https"]');

                if ($domain.val() == '') {
                    $sslField.hide();
                } else {
                    $sslField.show();
                }

                $domain.on('keyup', function(){
                    if ($(this).val() == '') {
                        $sslField.hide();
                    } else {
                        $sslField.show();
                    }
                });
            }
        })
    };

    _bindForm = () => {
        let self = this;

        if (!self._state.modal && !self._state.modal.length) return;

        let $form = self._state.modal.find('form');
        if (!$form) return;

        if (!Object.keys(self._state.item).length) {
            $form.find('.form-highlight[data-name="parts-highlight"]').show();
            $form.find('.form-highlight[data-name="parts-highlight"]').children('.form-slider').each(function(){
                if ($(this).data('id') != 10) {
                    $(this).show();
                }
            });
            $form.find('select[name="site[site_color]"]').trigger('change');
            $form.find('select[name="site[site_template]"]').trigger('change');
            $form.find('.facade-minicolors').parents('.form-highlight').show();
            $form.find('.chess-minicolors').parents('.form-highlight').show();
            $form.find('input.minicolors').removeAttr('disabled');
            $form.find('input.minicolors').removeAttr('disabled');
            $form.find('input').each(function(){
                if ($(this).data('name') != undefined && ( $(this).data('name').indexOf('display_name') != -1 || $(this).data('name').indexOf('subtitle') != -1) ) {
                    $(this).removeAttr('disabled');
                }
            });
        }

        tinymce.remove();
        $form.find('.form-slider[data-default="0"]:not(.disabled)').each(function(){
            let $textarea = $(this).find('textarea[name^=site]');
            $textarea.removeAttr('required');
            tinymce.init({
                selector: '#' + $textarea.attr('id'),
                plugins: [
                    "advlist anchor autolink contextmenu fullscreen help",
                    " lists link preview searchreplace image imagetools"
                ],
                toolbar: "insertfile undo redo | styleselect | bold italic | bullist numlist | link image",
                setup: function (editor) {
                    editor.on('change', function () {
                        editor.save();
                    });
                }
            });
        });

        $form.find('select[name="site[object]"]').change(function(){
            const val = $(this).val();
            $form.children('.form-field[data-name="site-buildings"]').slideDown();
            $form.find('.modal-building__checklist').slideUp();
            $form.find('.modal-building__checklist[data-complex-id="' + val + '"]').slideDown();
        });

        $form.find('.js-sortable-selected > ol').sortable({
            connectWith: '.js-sortable > ol',
            update: function(event, ui){
                $form.find('.form-highlight[data-name="parts-highlight"]').slideDown();
                const sortedIDs = $form.find('.js-sortable-selected > ol').sortable('toArray');

                let $templateSelect = $form.find('select[name="site[site_template]"]');
                let $colorSelect = $form.find('select[name="site[site_color]"]');

                $form.find('input[name="site[parts]"]').val(sortedIDs.join(','));
                if (sortedIDs.indexOf('1') != -1) {
                    $form.find('.facade-minicolors').parents('.form-highlight').slideDown();
                    $form.find('.facade-minicolors .minicolors-input').each(function(){
                        $(this).attr('required', 'required').removeAttr('disabled');
                    });
                    $form.find('input[name="site[if_stroke_width]"]').attr('required', 'required').removeAttr('disabled');

                    $templateSelect.trigger('change');
                    $colorSelect.trigger('change');
                }
                else {
                    $form.find('.facade-minicolors').parents('.form-highlight').slideUp();
                    $form.find('.facade-minicolors .minicolors-input').each(function () {
                        $(this).removeAttr('required').attr('disabled', 'disabled');
                    });
                    $form.find('input[name="site[if_stroke_width]"]').removeAttr('required').attr('disabled', 'disabled');
                }
                if (sortedIDs.indexOf('4') != -1) {
                    $form.find('.chess-minicolors').parents('.form-highlight').slideDown();
                    $form.find('.chess-minicolors .minicolors-input').each(function(){
                        $(this).attr('required', 'required').removeAttr('disabled');
                    });
                    $templateSelect.trigger('change');
                    $colorSelect.trigger('change');
                }
                else {
                    $form.find('.chess-minicolors').parents('.form-highlight').slideUp();
                    $form.find('.chess-minicolors .minicolors-input').each(function () {
                        $(this).removeAttr('required').attr('disabled', 'disabled');
                    });
                }

                $form.find('.form-highlight[data-name="parts-highlight"] .form-slider').each(function(){
                    $(this).addClass('disabled');
                    $(this).css({'display': 'none'});
                    $(this).find('input').each(function(){
                        let $input = $(this);
                        if ($input.attr('disabled') == 'disabled') $input.addClass('disabled');
                        $input.attr('disabled', 'disabled');
                    });
                    $(this).find('textarea').attr('disabled', 'disabled');
                });
                let i = 0;
                let ids = [];
                sortedIDs.forEach(function(id){
                    let flag = false;
                    if (id.indexOf('10-') != -1 && $(ui.item).attr('id') == id ){
                        let $items = $form.find('.form-highlight[data-name="parts-highlight"] .form-slider[data-id="10"][data-default="1"]');
                        let $existsItem = $form.find('.form-highlight[data-name="parts-highlight"] .form-slider[data-tid=' + $(ui.item).data('id') + ']');
                        if ($existsItem.length) {
                            flag = true;
                            return;
                        }
                        
                        let $newItem = $('<div />')
                            .addClass('form-slider')
                            .attr('data-default', 0)
                            .attr('data-id', id)
                            .attr('data-tid', $(ui.item).data('id'))
                            .css({'display': 'block', 'order': sortedIDs.indexOf(id)})
                            .html($items.html());

                        $newItem.children('.form-slider__title').text($(ui.item).text());

                        $newItem.find('input')
                            .removeAttr('disabled');

                        $newItem.find('textarea')
                            .removeAttr('disabled');

                        $newItem.find('[data-name="part_10_display_name_in_nav"]')
                            .attr('name', 'site[part_10_' + $(ui.item).data('id') + '_display_name_in_nav]')
                            .val('');
                        $newItem.find('[data-name="part_10_display_name_in_section"]')
                            .attr('name', 'site[part_10_' + $(ui.item).data('id') + '_display_name_in_section]');
                        $newItem.find('[data-name="part_10_subtitle_in_section"]')
                            .attr('name', 'site[part_10_' + $(ui.item).data('id') + '_subtitle_in_section]');

                        $newItem.find('[data-name="part_10_text_sort"]')
                            .val($(ui.item).index() + 1)
                            .attr('name', 'site[part_10_' + $(ui.item).data('id') + '_text_sort]');

                        $newItem.find('[data-name="part_10_text_place"]')
                            .attr('name', 'site[part_10_' + $(ui.item).data('id') + '_text_place]');

                        $newItem.find('[data-name="part_10_text_building_place"]')
                            .attr('name', 'site[part_10_' + $(ui.item).data('id') + '_text_building_place]');
                        $newItem.find('[data-name="part_10_text_building_place"][value=0]')
                            .attr('disabled', 'disabled');
                        $newItem.find('[data-name="part_10_text_section_place"]')
                            .attr('name', 'site[part_10_' + $(ui.item).data('id') + '_text_section_place]');
                        $newItem.find('[data-name="part_10_text_section_place"][value=0]')
                            .attr('disabled', 'disabled');
                        $newItem.find('[data-name="part_10_text_floor_place"]')
                            .attr('name', 'site[part_10_' + $(ui.item).data('id') + '_text_floor_place]');
                        $newItem.find('[data-name="part_10_text_floor_place"][value=0]')
                            .attr('disabled', 'disabled');

                        $newItem.find('[data-name="part_10_text_place_all_buildings"]')
                            .attr('name', 'site[part_10_' + $(ui.item).data('id') + '_text_place_all_buildings]')
                            .val(1);
                        $newItem.find('[data-name="part_10_text_place_all_buildings"]').parent().addClass('checked');
                        $newItem.find('[data-name="part_10_text_place_buildings"]')
                            .attr({
                                'name': 'site[part_10_' + $(ui.item).data('id') + '_text_place_buildings][]',
                                'disabled': 'disabled'
                            });

                        $newItem.find('[data-name="part_10_text_place_all_sections"]')
                            .attr('name', 'site[part_10_' + $(ui.item).data('id') + '_text_place_all_sections]')
                            .val(1);
                        $newItem.find('[data-name="part_10_text_place_all_sections"]').parent().addClass('checked');
                        $newItem.find('[data-name="part_10_text_place_sections"]')
                            .attr({
                                'name': 'site[part_10_' + $(ui.item).data('id') + '_text_place_sections][]',
                                'disabled': 'disabled'
                            });

                        $newItem.find('[data-name="part_10_text_place_all_floors"]')
                            .attr('name', 'site[part_10_' + $(ui.item).data('id') + '_text_place_all_floors]')
                            .val(1);
                        $newItem.find('[data-name="part_10_text_place_all_floors"]').parent().addClass('checked');
                        $newItem.find('[data-name="part_10_text_place_floors"]')
                            .attr({
                                'name': 'site[part_10_' + $(ui.item).data('id') + '_text_place_floors][]',
                                'disabled': 'disabled'
                            });

                        $newItem.find('[data-name="part_10_text"]')
                            .attr('name', 'site[part_10_' + $(ui.item).data('id') + '_text]')
                            .attr('id', 'part_10_' + $(ui.item).data('id') + '_text');

                        $newItem.find('input[data-name="part_10_text_place"]').on('change', function(){
                            let $currentRadio = $(this);
                            let $field = $currentRadio.parents('.form-field');
                            $newItem.find('input[data-name="part_10_text_place"]').each(function(){
                                let $radio = $(this);
                                let $ol = $radio.parent().next('ol');
                                if (!$ol.length) return;

                                $ol.hide();
                                $ol.find('a.checkbox').removeClass('checked').trigger('change');
                                $ol.find('input[value=0]').attr('disabled', 'disabled');
                                $ol.find('input[value=1]').attr('disabled', 'disabled');
                            });
                            let $ol = $currentRadio.parent().next('ol');
                            $ol.show();
                            $ol.find('a').addClass('checked').trigger('change');
                            $ol.find('input[value=1]').removeAttr('disabled');
                            $ol.find('input[value=0]').attr('disabled', 'disabled');

                            if ($currentRadio.val() == 'floor') {
                                $field.find('.select-checkbox[data-name="floors"]').show();
                            }
                        });

                        $newItem.find('.form-field__radio a.checkbox').on('change', function(){
                            let $checkbox      = $(this);
                            let $field         = $checkbox.parents('.form-field');
                            let $buildingPlace = $checkbox.children('input[data-name="part_10_text_building_place"]');
                            let $sectionPlace  = $checkbox.children('input[data-name="part_10_text_section_place"]');
                            let $floorPlace    = $checkbox.children('input[data-name="part_10_text_floor_place"]');

                            let $textPlace = $checkbox.parents('ol').prev('label').children('input[data-name="part_10_text_place"]');
                            const showBuildings = $textPlace.val() === 'building' && $textPlace.is(':checked') ? true : false;
                            const showSections  = $textPlace.val() === 'section' && $textPlace.is(':checked') ? true : false;
                            if( $buildingPlace.length || showBuildings ) {
                                let $buildingSelectCheckbox = $field.find('.select-checkbox[data-name="buildings"]');
                                if ($checkbox.hasClass('checked') || showBuildings) {
                                    $buildingSelectCheckbox.show();
                                } else {
                                    $buildingSelectCheckbox.hide();
                                }
                            }
                            if( $sectionPlace.length || showSections ) {
                                let $sectionSelectCheckbox = $field.find('.select-checkbox[data-name="sections"]');
                                if($checkbox.hasClass('checked') || showSections) {
                                    $sectionSelectCheckbox.show();
                                } else {
                                    $sectionSelectCheckbox.hide();
                                }
                            }
                            if( $floorPlace.length
                                ||
                                $checkbox.parents('ol').prev('label').children('input[data-name="part_10_text_place"]').val() === 'floor'
                            ) {
                                let $floorSelectCheckbox = $field.find('.select-checkbox[data-name="floors"]');
                                if($checkbox.hasClass('checked')){
                                    $floorSelectCheckbox.show();
                                } else {
                                    $floorSelectCheckbox.hide();
                                }
                            }
                        });

                        $form.find('.form-highlight[data-name="parts-highlight"]').append($newItem);

                        $newItem.find('.select-checkbox').show();

                        ids.push(parseInt($(ui.item).data('id')));
                    }

                    if (id.indexOf('10-') != -1){
                        let $item = $form.find('.form-highlight[data-name="parts-highlight"] .form-slider[data-id="' + id + '"][data-default="0"]');

                        if ($(ui.item).attr('id') != id || flag)
                            ids.push(parseInt($item.data('tid')));
                        $item.removeClass('disabled').css({'display': 'block', 'order': sortedIDs.indexOf(id)});

                        $item.find('[data-name="part_10_text_sort"]')
                            .val(i + 1);

                        $item.find('input').each(function(){
                            let $input = $(this);
                            if(
                                $input.data('name') == 'part_10_text_place_buildings'
                                ||
                                $input.data('name') == 'part_10_text_place_sections'
                                ||
                                $input.data('name') == 'part_10_text_place_floors'
                            ){
                                if($input.parent().hasClass('checked'))
                                    $input.removeAttr('disabled');
                            }
                            else {
                                if(!$input.hasClass('disabled'))
                                    $input.removeAttr('disabled');
                                else
                                    $input.removeClass('disabled');
                            }
                        });
                        $item.find('textarea').removeAttr('disabled').removeAttr('required');

                        let $textarea = $item.find('textarea[name^=site]');
                        if (!$textarea.length) return;

                        if(tinymce.get('#' + $textarea.attr('id'))) {
                            tinymce.get('#' + $textarea.attr('id')).remove();
                        }
                        tinymce.init({
                            selector: '#' + $textarea.attr('id'),
                            plugins: 'advlist',
                            advlist_bullet_styles: 'square',
                            toolbar: "insertfile a11ycheck undo redo | bold italic | forecolor backcolor | template codesample | alignleft aligncenter alignright alignjustify | bullist numlist | link image",
                            setup: function (editor) {
                                editor.on('change', function () {
                                    editor.save();
                                });
                            }
                        });
                    }
                    else {
                        let $item = $form.find('.form-highlight[data-name="parts-highlight"] .form-slider[data-id="' + id + '"]');
                        $item.css({'display': 'block', 'order': sortedIDs.indexOf(id)});
                        $item.find('input').removeAttr('disabled');
                        $item.find('textarea').removeAttr('disabled');
                    }
                    i++;

                    $form.find('[data-name="part_10_text_indexes"]').val(ids.join()).removeAttr('disabled');
                });
            }
        });

        $form.find('.js-sortable-unselected > ol').sortable({
            connectWith: '.js-sortable > ol',
            helper: function(event, ui){
                if ($(ui).attr('id') == 10 && !$(ui).hasClass('cloned')){
                    ui.clone().insertAfter(ui);
                    $(ui).addClass('cloned');

                    let maxNumber = 0;
                    $form.find('.js-sortable-unselected > ol > li[id^=10]').each(function(){
                        if (parseInt($(this).data('id')) > 0 && parseInt($(this).data('id')) > maxNumber)
                            maxNumber = parseInt($(this).data('id'));
                    });
                    $form.find('.js-sortable-selected > ol > li[id^=10]').each(function(){
                        if (parseInt($(this).data('id')) > 0 && parseInt($(this).data('id')) > maxNumber)
                            maxNumber = parseInt($(this).data('id'));
                    });
                    $(ui).attr('data-id', parseInt(maxNumber + 1));
                    $(ui).attr('id', '10-' + parseInt(maxNumber + 1));

                    $(ui).text('Текстовый блок №' + parseInt(maxNumber + 1));
                    return ui.clone();
                }
                else
                    return ui;
            },
            stop: function(event, ui){
                if ($(ui.item).attr('id').indexOf('10-') != -1){
                    if (!$(ui.item).hasClass('cloned')){
                        let $cloned = ui.item.data("multi-sortable");
                        ui.item.removeData("multi-sortable");
                        ui.item.after($cloned);
                        ui.item.siblings(":hidden").remove();
                        if ($(ui.item).parents('.js-sortable').hasClass('js-sortable-unselected')) {
                            ui.item.remove();
                        }
                    }
                    else {
                        if ($(ui.item).parents('.js-sortable').hasClass('js-sortable-unselected')) {
                            ui.item.remove();
                        }
                    }
                }
                else
                    return ui;
            }
        });

        $form.find('input[data-name="part_10_text_place"]').on('change', function(){
            let $currentRadio = $(this);
            let $field = $currentRadio.parents('.form-field');

            let $buildingSelectCheckbox = $field.find('.select-checkbox[data-name="buildings"]');
            let $sectionSelectCheckbox = $field.find('.select-checkbox[data-name="sections"]');
            $buildingSelectCheckbox.hide();
            $sectionSelectCheckbox.hide();

            $field.find('input[data-name="part_10_text_place"]').each(function(){
                let $radio = $(this);
                let $ol = $radio.parent().next('ol');
                if (!$ol.length) return;

                $ol.hide();
                $ol.find('a').removeClass('checked').trigger('change');
                $ol.find('input[value=0]').attr('disabled', 'disabled');
                $ol.find('input[value=1]').attr('disabled', 'disabled');
            });

            let $ol = $currentRadio.parent().next('ol');
            $ol.show();
            $ol.find('a').addClass('checked').trigger('change');
            $ol.find('input[value=1]').removeAttr('disabled');
            $ol.find('input[value=0]').attr('disabled', 'disabled');

            if ($currentRadio.val() == 'floor'){
                $field.find('.select-checkbox[data-name="floors"]').show();
            }
        });

        $form.find('.form-field__radio a.checkbox').on('change', function(){
            let $checkbox      = $(this);
            let $field         = $checkbox.parents('.form-field');
            let $buildingPlace = $checkbox.children('input[data-name="part_10_text_building_place"]');
            var $sectionPlace  = $checkbox.children('input[data-name="part_10_text_section_place"]');
            var $floorPlace    = $checkbox.children('input[data-name="part_10_text_floor_place"]');

            let $textPlace      = $checkbox.parents('ol').prev('label').children('input[data-name="part_10_text_place"]');
            const showBuildings = $textPlace.val() == 'building' && $textPlace.is(':checked') ? true : false;
            const showSections  = $textPlace.val() == 'section' && $textPlace.is(':checked') ? true : false;
            if ( $buildingPlace.length || showBuildings ) {
                let $buildingSelectCheckbox = $field.find('.select-checkbox[data-name="buildings"]');
                if ($checkbox.hasClass('checked') || showBuildings) {
                    $buildingSelectCheckbox.show();
                } else {
                    $buildingSelectCheckbox.hide();
                }
            }
            if( $sectionPlace.length || showSections ){
                let $sectionSelectCheckbox = $field.find('.select-checkbox[data-name="sections"]');
                if ($checkbox.hasClass('checked') || showSections) {
                    $sectionSelectCheckbox.show();
                } else {
                    $sectionSelectCheckbox.hide();
                }
            }
            if(
                $floorPlace.length
                ||
                $checkbox.parents('ol').prev('label').children('input[data-name="part_10_text_place"]').val() === 'floor'
            ){
                let $floorSelectCheckbox = $field.find('.select-checkbox[data-name="floors"]');
                if ($checkbox.hasClass('checked')) {
                    $floorSelectCheckbox.show();
                } else {
                    $floorSelectCheckbox.hide();
                }
            }
        });

        $form.find('select[name="site[site_color]"]').change(function(){
            let $select = $(this);
            let $option = $select.children(':selected');
            $form.find('input[name="site[color_1]"]').minicolors('value', $option.data('color_1'));
            $form.find('input[name="site[color_2]"]').minicolors('value', $option.data('color_2'));
            $form.find('input[name="site[color_3]"]').minicolors('value', $option.data('color_3'));
            $form.find('input[name="site[color_4]"]').minicolors('value', $option.data('color_4'));
            $form.find('input[name="site[if_color_1]"]').minicolors('value', $option.data('if_color_1'));
            $form.find('input[name="site[if_color_2]"]').minicolors('value', $option.data('if_color_2'));
            $form.find('input[name="site[if_color_3]"]').minicolors('value', $option.data('if_color_3'));
            $form.find('input[name="site[if_color_4]"]').minicolors('value', $option.data('if_color_4'));
            $form.find('input[name="site[chess_color_1]"]').minicolors('value', $option.data('chess_color_1'));
            $form.find('input[name="site[chess_color_2]"]').minicolors('value', $option.data('chess_color_2'));
            $form.find('input[name="site[chess_color_3]"]').minicolors('value', $option.data('chess_color_3'));
            $form.find('input[name="site[chess_color_4]"]').minicolors('value', $option.data('chess_color_4'));
            $form.find('select[name="site[if_stroke_width]"]').val(2);
        });

        $form.find('.minicolors').each(function(){
            if ($(this).attr('name').indexOf('chess') != -1) {
                $(this).minicolors({
                    format: 'rgb'
                });
            }
            else {
                $(this).minicolors({
                    format: 'rgb',
                    opacity: true
                });
            }
        });

        $form.find('input.minicolors').change(function(){
            let $select = $form.find('select[name="site[site_color]"]');
            let $option = $select.children(':selected');
            let $input = $(this);
            if ($option.data($input.data('name')) === undefined) $select.val(1);

            $option = $select.children(':selected');
            if ($option.data($input.data('name')) !== undefined && $option.data($input.data('name')).replace(/\s/g, '') != $input.val().replace(/\s/g, '')){
                $select.children('option[value=1]').data($input.data('name'), $input.val().replace(/\s/g, ''));
                $select.val(1);
            }
        });

        if (self._state.item) return;

        let $buildingAllInput = $form.find('input[name="site[building_all]"]');
        $buildingAllInput.val(1);
        $buildingAllInput.parent().addClass('checked');

        let $templateSelect = $form.find('select[name="site[site_template]"]');
        let $colorSelect = $form.find('select[name="site[site_color]"]');
        $templateSelect.val(2).trigger('change');
        $colorSelect.val(2).trigger('change');

        $form.find('.form-highlight[data-name="parts-highlight"] .form-slider').each(function(){
            if ($(this).data('id') != 10) {
                $(this).find('input[type=text]').removeAttr('disabled');
            }
        });
    };

    _bindSubmit = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let validation = new Validation({
            form : $form
        });

        $form.find('textarea').each(function(){
            let $textarea = $(this);
            $textarea.val(sanitizeHtml($textarea.val(), {
                allowedTags : [
                    'a',
                    'ul',
                    'ol',
                    'li',
                    'br',
                    'p',
                    'strong',
                    'em',
                    'h3',
                    'h4',
                    'h5',
                    'h6',
                    'span',
                    'sup',
                    'sub',
                    'blockquote',
                    'img'
                ],
                replace: [
                    [["b", "big"], "strong"],
                    [["i"], "em"],
                    [["h1", "h2"], "h3"]
                ],
                allowedAttributes: [["target"]]
            }));
        });

        loader.increase();

        Request.send({
            path   : '/api/' + self._const.entities + '/' + (Object.keys(self._state.item).length ? self._state.item[self._const.id] + '/edit' : 'create'),
            method : 'POST',
            data   : $form.serialize(),

            done: function(response) {
                loader.decrease();

                if (response.error) {
                    validation.showErrors(response.error);
                    return
                }

                self._state.item  = response[self._const.entity];
                self._state.items = {};

                $modal.trigger('close');

                if(self._args.mode === Vars.view.index || self._args.mode === Vars.view.list) {
                    window.location.href = '#' + self._const.entities + '/' + self._state.item.site_id;
                } else {
                    self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                        crumbs : [
                            {
                                title : 'Главная',
                                href  : '#'
                            },
                            {
                                title : 'Сайты',
                                href  : '#sites'
                            },
                            {
                                title : self._state.item.object.name
                            }
                        ],
                        dropdown : null,
                        activate : self._state.item.is_default ? null : {
                            id        : self._state.item.site_id,
                            is_active : self._state.item.is_active
                        }
                    });

                    self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                        breadcrumbs          : self._state.breadcrumbs,
                        [self._const.entity] : self._state.item
                    }));
                    self._bindElements();
                    self._bindUI();
                }
            }
        });
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;

        self._elems.$create    = self._elems.$content.find('.js-profile-site-create');
        self._elems.$edit      = self._elems.$content.find('.js-profile-site-edit');
        self._elems.$params    = self._elems.$content.find('.js-profile-site-params-edit');
        self._elems.$crmAttach = self._elems.$content.find('.js-profile-crm-attach');
        self._elems.$crmDetach = self._elems.$content.find('.js-profile-crm-detach');
    };

    _bindActions = () => {
        let self = this;

        new Action({
            id       : self._state.item.site_id,
            actions  : self._actions,
            entities : self._const.entities,
            entity   : self._const.entity,
            self     : self
        });
    };

    _bindParamsSubmit = (args) => {
        let self = this;

        loader.increase();

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        let validation = new Validation({
            form : $form
        });

        Request.send({
            path: '/api/' + self._const.entities + '/' + self._state.item[self._const.id] + '/edit/params',
            method: 'POST',
            data: $form.serialize(),
            done: function (response) {
                loader.decrease();

                if (response.error) {
                    validation.showErrors(response.error);
                    return
                }

                self._state.item = response[self._const.entity];
                $modal.trigger('close');

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item
                }));
                self._bindElements();
                self._bindUI();

                if(!response.send) return;

                new Modal({
                    title   : 'Запрос на подключение домена',
                    content : Utils.renderProfileTemplate('info', {
                        message : 'Запрос на подключение домена отправлен. Необходимые уточнения можно отправить сообщением в <a href="/profile/#conversations/support" target="_blank">техподдержку</a>',
                        buttons : {
                            one : {
                                class : 'confirm button--edit',
                                title : 'Хорошо'
                            },
                            two : null
                        }
                    })
                });
            }
        });
    };

    _bindUI = () => {
        let self = this;

        self._elems.$create.length && self._elems.$create.unbind('click').on('click', function(e) {
            e.preventDefault();
            self._initModal();
        });

        self._elems.$edit.length && self._elems.$edit.unbind('click').on('click', function(e) {
            e.preventDefault();
            self._initModal();
        });

        self._elems.$params.length && self._elems.$params.unbind('click').on('click', function(e) {
            e.preventDefault();
            self._initParams();
        });

        self._elems.$crmAttach.length && self._elems.$crmAttach.unbind('click').on('click', function(e) {
            e.preventDefault();

            loader.increase();

            Request.send({
                path: '/api/crms',
                done: function (response) {
                    loader.decrease();
                    Utils.scrollToTop();

                    self._state.crms = response.crms;
                    self._attachCrm();
                }
            });
        });

        self._elems.$crmDetach.length && self._elems.$crmDetach.unbind('click').on('click', function(e) {
            e.preventDefault();

            const id = $(this).data('id');
            self._detachCrm(id);
        });

        self._bindActions();
    };

    _index = () => {
        let self = this;
        self._bindElements();
        self._bindUI();
    };

    _list = () => {
        let self = this;

        self._bindElements();

        Request.send({
            queue: [
                {
                    path: '/api/' + self._const.entities
                },
                {
                    path: '/api/counts?only=objects'
                }
            ],
            done: function(response, extraResponse) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.items   = response[self._const.entities];
                const counts        = extraResponse.counts ? extraResponse.counts : [];
                const objects       = Object.keys(counts).length && counts.objects ? counts.objects : 0;

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Сайты'
                        }
                    ],
                    dropdown : null,
                    activate : null
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entities, {
                    breadcrumbs            : self._state.breadcrumbs,
                    [self._const.entities] : self._state.items,
                    objects                : objects
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _item = () => {
        let self = this;

        self._bindElements();

        Request.send({
            path: '/api/' + self._const.entities + '/' + self._args.id + '?only=' + self._const.entity,
            data : {
                info : 'short'
            },
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                if (response.error) {
                    window.location.href = '/profile#' + self._const.entities;
                    return;
                }

                self._state.item  = response[self._const.entity];
                self._state.items = {};

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Главная',
                            href  : '#'
                        },
                        {
                            title : 'Сайты',
                            href  : '#sites'
                        },
                        {
                            title : self._state.item.object.name
                        }
                    ],
                    dropdown : null,
                    activate : self._state.item.is_default ? null : {
                        id        : self._state.item.site_id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    [self._const.entity] : self._state.item
                }));

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this;

        if (self._args.mode === Vars.view.index) {
            self._index();
        } else if (self._args.mode === Vars.view.list) {
            self._list();
        } else if (self._args.mode === Vars.view.item) {
            self._item();
        }
    };
}

export default Site;